import React from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import Logger from "ui/common/logger/Logger";
import Loading from "ui/common/loading/Loading";
import Column from "../components/Column";

class LoadingColumn extends React.Component {

	render() {
		return(
			<Column
				id="loading"
				title={ this.props.configuration.interface.chat.title }
			>
				<Loading titleVisible={ false } />
				{this.props.configuration.debug &&
					<Logger/>
				}
			</Column>
		)
	}

}

LoadingColumn.propTypes = {
	configuration: PropTypes.object.isRequired
};

export default connect(
	(state) => ({
		configuration: state.configuration
	})
)(LoadingColumn);